<template id="organizationsTmpl">
		<ct-main-layout-appcommerciale :backurl="backurl" :breadcrumbs="breadcrumbs" >
			
			<v-card>
				<!-- TITLE -->
				<v-card-title>
					{{ $t('lbl.organizations')}}
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<ct-form-create-org></ct-form-create-org>
				</v-card-text>

				<v-divider></v-divider>

				<!-- LISTA ORGANIZZAZIONI-->
				<v-card-text>
					<v-data-table :headers="headersOrganizations" :items="organizations" :no-data-text="$t('err.noelem')" :loading="$root.loading" class="elevation-1">
						<template v-slot:body="{ items }">
							<tbody>
							<tr v-for="item in items" :key="item.organization_id" >
								<td class="font-weight-bold">{{ item.organization_name }}</td>
								<td width="20%" class="text-right">

									<v-tooltip top> 
										<template v-slot:activator="{ on, attrs }">
											<v-btn 
											class="button-secondary ma-1" fab small depressed 
											v-bind="attrs"
											v-on="on" 
											@click="$root.goToPage('/appcommerciale/organization/' + item.organization_id)"
											><v-icon>create</v-icon></v-btn>
										</template>
										<span>{{ $t('btn.edit')}}</span>
									</v-tooltip>	
									
									<v-tooltip top> 
										<template v-slot:activator="{ on, attrs }">
											<v-btn 
												class="button-secondary ma-1" fab small depressed 
												v-bind="attrs"
												v-on="on" 
												v-on:click="deleteOrganization(item.organization_id)"
												><v-icon>delete</v-icon></v-btn>
										</template>
										<span>{{ $t('btn.delete')}}</span>
									</v-tooltip>
											
								</td>
							</tr>
							</tbody>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
			
		</ct-main-layout-appcommerciale>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctFormCreateOrgComponent from "@/components/appcommerciale/ctFormCreateOrg.vue";

export default {
	i18n,
	data: () => ({
		backurl: '/apps',
		breadcrumbs:[],
		headersOrganizations: [
			{ text: i18n.t('lbl.organizations'), align: 'left', value: 'organization_name'},
			{ text: '', align: 'center'}
		],
		organizations: [],
	}),
	components: 
	{
        'ct-form-create-org': ctFormCreateOrgComponent
	},
	mounted() 
	{
		//=== NAVIGATION BAR
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appcommerciale'), disabled: false, href: '/tools/appcommerciale' }
		]
		
		//=== LISTENERS
		events.$on('newOrgCreated', () => {
			this.loadOrganizations();			
		});
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.headersOrganizations = [
				{ text: i18n.t('lbl.organizations'), align: 'left', value: 'organization_name'},
				{ text: '', align: 'center'}	
			]
		});

		//=== STARTUP
		this.loadOrganizations();
	},
	destroyed() 
	{
		events.$off('newOrgCreated');
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	methods: 
	{
		loadOrganizations() 
		{
			this.$root.genericGetAuthenticatedCallEngine(constants.ENDPOINT_ORGANIZATIONS, this.callbackLoadOrganizations, 'err.loadingSites');
		},
		callbackLoadOrganizations(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.organizations =  responseData.organizations;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSites"));
			}
		},
		deleteOrganization(orgId)
		{
			if(!this.isEmptyString(orgId))
			{
				if(confirm(i18n.t('lbl.organization') + " " +orgId + " - " + i18n.t('msg.confirmDelete')))
				{	
					//=== PRIMA CONTROLLARE CHE NON CI SIANO UTENTI PRESENTI
					var endpoint2go = constants.ENDPOINT_USER + '?organization_id=' + orgId;
					
					this.$root.loading = true;
					var myUser = this.getUser();
					this.axios
						.get(endpoint2go, this.getMyAuthHeader(myUser))
						.then(response => {
							if(response.status == 200)
							{	
								this.$root.loading = false; 
								// PER QUESTO MOTIVO NON POSSO USARE LE FUNZIONI BASE
								this.callbackLoadUsers4Delete(orgId, response.data);
							} 
							else if(response.status == 401)
							{
								this.$root.tokenExpired();
							} 
							else 
							{
								this.$root.setDialogMsg(i18n.t('err.loadingUsers'));
							}
						})
						.catch(error => {
							this.$root.loading = false; 
							this.$root.setDialogMsg(i18n.t('err.loadingUsers'));
						});
					
				} 
			}	
		},
		callbackLoadUsers4Delete(orgId, responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				if(!this.isEmptyObj(responseData.users) && Array.isArray(responseData.users) && responseData.users.length > 0 )
				{
					this.$root.setDialogMsg(i18n.t('err.beforeDeleteOrganizationDeleteAllUser'));
				} 
				else 
				{
					//=== POI DEVO CONTROLLARE CHE NON CI SIANO PROGETTI PRESENTI
					var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + orgId + '/projects';
					
					this.$root.loading = true;
					var myUser = this.getUser();
					this.axios
						.get(endpoint2go, this.getMyAuthHeader(myUser))
						.then(response => {
							if(response.status == 200)
							{	
								this.$root.loading = false; 
								// PER QUESTO MOTIVO NON POSSO USARE LE FUNZIONI BASE
								this.callbackLoadProjects4delete(orgId, response.data);
							} 
							else if(response.status == 401)
							{
								this.$root.tokenExpired();
							} 
							else 
							{
								this.$root.setDialogMsg(i18n.t('err.loadingPrjs'));
							}
						})
						.catch(error => {
							this.$root.loading = false; 
							this.$root.setDialogMsg(i18n.t('err.loadingPrjs'));
						});
					
				}
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingUsers'));
			}
		},
		callbackLoadProjects4delete(orgId, responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				if(!this.isEmptyObj(responseData.projects) && Array.isArray(responseData.projects) && responseData.projects.length > 0 )
				{
					this.$root.setDialogMsg(i18n.t('err.beforeDeleteOrganizationDeleteAllProjects'));
				} else 
				{
					this.doDeleteOrganization(orgId);
				}
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingPrjs'));
			}
		},
		doDeleteOrganization(orgId)
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + orgId;
			this.$root.genericDeleteAuthenticatedCallEngine(endpoint2go, this.callbackDeleteOrganization);
		},
		callbackDeleteOrganization(responseData) 
		{
			this.loadOrganizations();
		},
	}
}
</script>